import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const MinimumInformation = styled("span")(() => ({
  color: "#667085",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  marginTop: "4px",
}));

export const MeasurementsWrapper = styled("div")(() => ({
  display: "flex",
  gap: 16,

  padding: 8,
  width: "100%",
}));

export const MeasurementsItem = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 4,
  maxWidth: "25%",
}));

export const StorageBoxUsagesWrapper = styled("div")(() => ({
  display: "flex",
  alignContent: "flex-start",
  justifyContent: "space-between",
  gap: 8,

  padding: 8,
  width: "100%",
}));

export const StorageBoxUsageItem = styled("div")(() => ({
  minWidth: "50%",
}));

export const StorageBoxRequireChecklistWrapper = styled(Grid)(() => ({
  maxWidth: "306px !important",
}));

export const StorageBoxRulesWrapper = styled(Grid)(() => ({}));

export const RulesWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
}));

export const ChecklistHeaderTitle = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "8px",
}));

export const CounterBadge = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  background: colors.gray600,
  color: colors.white,
  borderRadius: "16px",
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "11px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  minHeight: "16px",
  minWidth: "16px",
}));

const styles = makeStyles(() => ({
  optionsLabel: {
    color: colors.gray600,
    fontSize: "16px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "0.5px",
  },
  radioGroupStyles: {
    display: "flex",
    gap: 16,
  },
  modalStyles: {
    width: "628px !important",
  },
  panel: {
    "& header": {
      background: colors.gray50,
      padding: "16px 24px",
    },
    background: colors.gray50,
  },
  panelContent: {
    padding: "24px",
  },
  checkboxGroup: {
    gap: "16px",
    justifyContent: "flex-start",
  },
}));

export default styles;
